module.exports = __webpack_public_path__ + "media/bootstrap-icons/shield-lock-fill-c3bb3374.svg";